export { default } from "./LeftAlignIcon";
